var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{staticStyle:{"background-color":"transparent"},attrs:{"close-on-click-overlay":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"loadingWrap"},[_c('van-loading',{attrs:{"color":"#F7D874","type":"spinner"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }